module.exports = __webpack_public_path__ + "img/road.d1f2b4cf.svg";